(function(){
  document.querySelectorAll('[data-market-switcher]').forEach(function(switcher){
    var form=switcher.querySelector('form');
    var trigger=switcher.querySelector('[data-market-trigger]');
    var menu=switcher.querySelector('[data-market-menu]');
    var countrySelect=switcher.querySelector('[data-market-select]');
    var languageInput=switcher.querySelector('[data-market-language]');
    function close(){
      if(!menu || !trigger) return;
      menu.hidden=true;
      trigger.setAttribute('aria-expanded','false');
    }
    function open(){
      if(!menu || !trigger) return;
      menu.hidden=false;
      trigger.setAttribute('aria-expanded','true');
    }
    if(trigger && menu){
      trigger.addEventListener('click',function(event){
        event.preventDefault();
        menu.hidden ? open() : close();
      });
      document.addEventListener('click',function(event){
        if(!switcher.contains(event.target)) close();
      });
      document.addEventListener('keydown',function(event){
        if(event.key === 'Escape') close();
      });
    }
    switcher.querySelectorAll('[data-market-option]').forEach(function(option){
      option.addEventListener('click',function(){
        if(countrySelect) countrySelect.value=option.getAttribute('data-country-code') || '';
        if(languageInput) languageInput.value=option.getAttribute('data-language') || languageInput.value;
        if(form) form.submit();
      });
    });
    if(countrySelect){
      countrySelect.addEventListener('change',function(){
        var selected=countrySelect.options[countrySelect.selectedIndex];
        if(languageInput && selected && selected.dataset.language) languageInput.value=selected.dataset.language;
        if(form) form.submit();
      });
    }
  });

  function refreshCartCount(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(cart){
      document.querySelectorAll('[data-cart-count]').forEach(function(node){node.textContent=cart.item_count;});
    }).catch(function(){});
  }

  document.querySelectorAll('[data-gallery]').forEach(function(gallery){
    var slides=[].slice.call(gallery.querySelectorAll('[data-slide]'));
    var thumbs=[].slice.call(gallery.querySelectorAll('[data-thumb]'));
    var active=0;
    function show(index){
      if(!slides.length) return;
      active=(index+slides.length)%slides.length;
      slides.forEach(function(slide,i){slide.classList.toggle('is-active',i===active);});
      thumbs.forEach(function(thumb,i){
        var isActive=i===active;
        thumb.classList.toggle('is-active',isActive);
        thumb.setAttribute('aria-current',isActive ? 'true' : 'false');
        if(isActive && typeof thumb.scrollIntoView === 'function'){
          thumb.scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
        }
      });
    }
    thumbs.forEach(function(thumb,i){thumb.addEventListener('click',function(){show(i);});});
    var prev=gallery.querySelector('[data-prev]');
    var next=gallery.querySelector('[data-next]');
    if(prev) prev.addEventListener('click',function(){show(active-1);});
    if(next) next.addEventListener('click',function(){show(active+1);});
  });

  var productPage=document.querySelector('[data-product-page]');
  if(productPage){
    var productCopy={
      atc: productPage.getAttribute('data-copy-atc') || 'Add to cart',
      soldOut: productPage.getAttribute('data-copy-sold-out') || 'Sold out',
      sticky: productPage.getAttribute('data-copy-sticky') || 'Choose your bundle',
      showMore: productPage.getAttribute('data-copy-show-more') || 'Show more reviews',
      showFewer: productPage.getAttribute('data-copy-show-fewer') || 'Show fewer reviews',
      offerName: productPage.getAttribute('data-property-offer-name') || 'Offer',
      offerValue: productPage.getAttribute('data-property-offer-value') || 'Mistglide Brush bundle',
      offerValueOne: productPage.getAttribute('data-property-offer-value-one') || '1x Mistglide Brush',
      offerValueTwo: productPage.getAttribute('data-property-offer-value-two') || '2x Mistglide Brush bundle',
      bundleSizeName: productPage.getAttribute('data-property-bundle-size-name') || 'Bundle size',
      brushNumberName: productPage.getAttribute('data-property-brush-number-name') || 'Brush number',
      colorOneName: productPage.getAttribute('data-property-color-one-name') || 'Brush 1 color',
      colorTwoName: productPage.getAttribute('data-property-color-two-name') || 'Brush 2 color',
      serumGiftName: productPage.getAttribute('data-property-serum-gift-name') || 'Free gift',
      serumGiftValue: productPage.getAttribute('data-property-serum-gift-value') || '1x Mistglide Nourishing Hair Oil'
    };
    var bundlePrices={
      1:Number(productPage.getAttribute('data-bundle-price-one') || 4999),
      2:Number(productPage.getAttribute('data-bundle-price-two') || 7999)
    };
    var bundleCompares={
      1:Number(productPage.getAttribute('data-bundle-compare-one') || 7999),
      2:Number(productPage.getAttribute('data-bundle-compare-two') || 9988)
    };
    var serumGiftVariantId=Number(productPage.getAttribute('data-serum-gift-variant-id') || 0);
    var defaultBundleTier=Number(productPage.getAttribute('data-bundle-default') || 1);
    var variantsNode=document.querySelector('[data-product-variants]');
    var variants=[];
    try{variants=JSON.parse(variantsNode ? variantsNode.textContent : '[]');}catch(e){}
    var variantInput=document.querySelector('[data-variant-id]');
    var colorLabels={
      1:document.querySelector('[data-color-label-one]'),
      2:document.querySelector('[data-color-label-two]')
    };
    var colorProps={
      1:document.querySelector('[data-property-color-one]'),
      2:document.querySelector('[data-property-color-two]')
    };
    var offerProp=document.querySelector('[data-property-offer]');
    var bundleSizeProp=document.querySelector('[data-property-bundle-size]');
    var priceNode=document.querySelector('[data-price]');
    var compareNode=document.querySelector('[data-compare]');
    var form=document.querySelector('[data-product-form]');
    var stickyAtc=document.querySelector('[data-sticky-atc]');
    var stickyAtcPrice=document.querySelector('[data-sticky-atc-price]');
    var bundleTarget=document.querySelector('[data-bundle-target]');
    var trustBadges=[].slice.call(document.querySelectorAll('.sc-trust p'));

    if(trustBadges[0] && /free delivery/i.test(trustBadges[0].textContent || '')) trustBadges[0].textContent='5-year guarantee';
    function money(cents){
      var config=window.HydraBrushMoney || {};
      var amount=Number(cents || 0)/100;
      var currency=String(config.currency || 'USD').toUpperCase();
      function withCurrencyCode(formatted){
        formatted=String(formatted || '');
        if(!currency || currency === 'EUR') return formatted;
        if(formatted.toUpperCase().indexOf(currency) !== -1) return formatted;
        return formatted + ' ' + currency;
      }
      if(currency === 'EUR'){
        try{
          return new Intl.NumberFormat('fr-FR', {
            minimumFractionDigits:2,
            maximumFractionDigits:2
          }).format(amount).replace(/\u202f/g, ' ') + ' €';
        }catch(e){
          return amount.toFixed(2).replace('.', ',') + ' €';
        }
      }
      try{
        return withCurrencyCode(new Intl.NumberFormat(config.locale || document.documentElement.lang || 'en', {
          style:'currency',
          currency:currency,
          currencyDisplay:'narrowSymbol'
        }).format(amount));
      }catch(e){
        return amount.toFixed(2) + ' ' + currency;
      }
    }
    function getVariantById(id){
      return variants.filter(function(v){return String(v.id)===String(id);})[0] || null;
    }
    function getSelectedTier(){
      var checked=document.querySelector('[data-bundle-tier]:checked');
      var tier=Number(checked ? checked.value : defaultBundleTier);
      return tier >= 1 && tier <= 2 ? tier : 1;
    }
    function getOfferValue(tier){
      if(tier === 1) return productCopy.offerValueOne;
      return productCopy.offerValueTwo;
    }
    function colorPropertyName(slot){
      if(slot === 1) return productCopy.colorOneName;
      return productCopy.colorTwoName;
    }
    function setSlotColor(input){
      var slot=Number(input.getAttribute('data-bundle-slot') || input.getAttribute('data-sc-color') || 1);
      var variant=variants.filter(function(v){return String(v.id)===String(input.value);})[0];
      if(!variant) return;
      if(slot === 1 && variantInput) variantInput.value=variant.id;
      var colorDisplay=input.getAttribute('data-color-display') || input.getAttribute('data-color-name') || variant.option1;
      if(colorLabels[slot]) colorLabels[slot].textContent=colorDisplay;
      if(colorProps[slot]) colorProps[slot].value=colorDisplay;
    }
    function getSelectedColor(slot){
      var input=document.querySelector('[data-bundle-color][data-bundle-slot="'+slot+'"]:checked');
      if(!input) return null;
      var variant=getVariantById(input.value);
      if(!variant) return null;
      return {
        slot:slot,
        variant:variant,
        color:input.getAttribute('data-color-display') || input.getAttribute('data-color-name') || variant.option1
      };
    }
    function updateBundleUi(){
      var tier=getSelectedTier();
      var price=bundlePrices[tier] || bundlePrices[2];
      var compare=bundleCompares[tier] || bundleCompares[2];
      if(priceNode) priceNode.textContent=money(price);
      if(compareNode) compareNode.textContent=money(compare);
      if(stickyAtcPrice) stickyAtcPrice.textContent=money(price);
      if(offerProp) offerProp.value=getOfferValue(tier);
      if(bundleSizeProp) bundleSizeProp.value=String(tier);
      document.querySelectorAll('[data-color-group]').forEach(function(group){
        var slot=Number(group.getAttribute('data-color-group') || 1);
        group.hidden=slot > tier;
      });
      var available=true;
      for(var i=1;i<=tier;i+=1){
        var selected=getSelectedColor(i);
        if(!selected || !selected.variant.available) available=false;
      }
      var atc=document.querySelector('.atc,.sc-atc');
      if(atc){
        atc.disabled=!available;
        atc.innerHTML=available ? productCopy.atc + ' - <span data-sc-atc-price>' + money(price) + '</span>' : productCopy.soldOut;
      }
      if(stickyAtc){
        stickyAtc.disabled=!available;
        stickyAtc.innerHTML=available ? productCopy.sticky + '&nbsp;<span data-sticky-atc-price>' + money(price) + '</span>' : productCopy.soldOut;
        stickyAtcPrice=stickyAtc.querySelector('[data-sticky-atc-price]');
      }
    }
    document.querySelectorAll('[data-bundle-tier]').forEach(function(input){
      input.addEventListener('change',updateBundleUi);
    });
    document.querySelectorAll('[data-bundle-color]').forEach(function(input){
      input.addEventListener('change',function(){
        setSlotColor(input);
        updateBundleUi();
      });
    });
    document.querySelectorAll('[data-bundle-color]:checked').forEach(setSlotColor);
    updateBundleUi();

    if(form){
      if(stickyAtc){
        stickyAtc.addEventListener('click',function(){
          var target=bundleTarget || form;
          if(!target) return;
          target.scrollIntoView({behavior:'smooth',block:'center'});
          var firstChoice=target.querySelector('[data-color-one]');
          if(firstChoice) {
            setTimeout(function(){ firstChoice.focus({preventScroll:true}); }, 450);
          }
        });

        if(bundleTarget && 'IntersectionObserver' in window){
          var stickyObserver=new IntersectionObserver(function(entries){
            entries.forEach(function(entry){
              stickyAtc.classList.toggle('is-hidden', entry.isIntersecting);
            });
          }, {threshold:0.28});
          stickyObserver.observe(bundleTarget);
        }
      }

      form.addEventListener('submit',function(event){
        event.preventDefault();
        if(form.dataset.atcBusy === 'true') return;
        form.dataset.atcBusy = 'true';
        var atcButton = form.querySelector('[type="submit"], .sc-atc, .atc');
        if(atcButton) atcButton.disabled = true;
        var tier=getSelectedTier();
        var offerValue=getOfferValue(tier);
        var replaceVariantIds=variants.map(function(variant){return Number(variant.id);}).filter(Boolean);
        if(serumGiftVariantId) replaceVariantIds.push(serumGiftVariantId);
        var items=[];
        for(var slot=1;slot<=tier;slot+=1){
          var selected=getSelectedColor(slot);
          if(!selected) continue;
          var properties={};
          properties[productCopy.offerName]=offerValue;
          properties[productCopy.bundleSizeName]=String(tier) + 'x';
          properties[productCopy.brushNumberName]=String(slot);
          properties[colorPropertyName(slot)]=selected.color;
          items.push({
            id:Number(selected.variant.id),
            quantity:1,
            properties:properties
          });
        }
        if(tier === 2 && serumGiftVariantId){
          var giftProperties={};
          giftProperties[productCopy.offerName]=offerValue;
          giftProperties[productCopy.bundleSizeName]='2x';
          giftProperties[productCopy.serumGiftName]=productCopy.serumGiftValue;
          giftProperties._gift='true';
          giftProperties._gift_source='2x-brush-bundle';
          items.push({
            id:serumGiftVariantId,
            quantity:1,
            properties:giftProperties
          });
        }
        if(items.length < tier){
          form.dataset.atcBusy = 'false';
          if(atcButton) atcButton.disabled = false;
          return;
        }
        document.dispatchEvent(new CustomEvent('cart:add',{
          detail:{
            items:items,
            source:'product-tier-bundle',
            replaceVariantIds:replaceVariantIds,
            onSuccess:function(){
              refreshCartCount();
              form.dataset.atcBusy = 'false';
              if(atcButton) atcButton.disabled = false;
            },
            onError:function(error){
              console.error('Product add-to-cart failed', error);
              form.dataset.atcBusy = 'false';
              if(atcButton) atcButton.disabled = false;
            }
          }
        }));
      });
    }
  }

  var reviewList=document.querySelector('[data-sc-review-list]');
  var reviewButton=document.querySelector('[data-sc-review-more]');
  if(reviewList && reviewButton){
    reviewButton.addEventListener('click',function(){
      var expanded=reviewList.classList.toggle('is-expanded');
      reviewButton.setAttribute('aria-expanded',expanded ? 'true' : 'false');
      var productCopyNode=document.querySelector('[data-product-page]');
      var moreText=productCopyNode ? productCopyNode.getAttribute('data-copy-show-more') : null;
      var fewerText=productCopyNode ? productCopyNode.getAttribute('data-copy-show-fewer') : null;
      reviewButton.textContent=expanded ? (fewerText || 'Show fewer reviews') : (moreText || 'Show more reviews');
    });
  }
})();
